import { useMutation, useQuery, useQueryClient, type UseMutationResult, type UseQueryResult } from '@tanstack/react-query'
import type { VenuePublicPageSettingsDto } from '@lib/dto/venue-public-page.dto'
import type { UpdateVenuePublicPageInput } from '@lib/input/venue-public-page.input'
import { venuePageService } from '@/services/VenuePageService'
import { venuePageKeys } from './queryKeys'

/** A venue's page on the public site, as Venue setup shows it. */
export function useVenuePublicPage(venueId: string): UseQueryResult<VenuePublicPageSettingsDto> {
  return useQuery({
    queryKey: venuePageKeys.settings(venueId),
    queryFn: () => venuePageService.settings(venueId),
  })
}

/** Change it; the answer is the page as it now stands. */
export function useUpdateVenuePublicPage(venueId: string): UseMutationResult<VenuePublicPageSettingsDto, Error, UpdateVenuePublicPageInput> {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: UpdateVenuePublicPageInput) => venuePageService.update(venueId, input),
    onSuccess: (settings) => queryClient.setQueryData(venuePageKeys.settings(venueId), settings),
  })
}
